import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  stock_movements: [],
};

const getters = {
  allStockMovements: (state) => state.stock_movements,
};

const actions = {
  async fetchStockMovements({ commit }, params = {}) {
    try {
      const response = await axios.get("/stock-movement", { params: prm(params) });
      commit("setStockMovements", response.data);
      return response.data
    } catch (error) {
      console.error("Failed to fetch stock_movements:", error);
    }
  },
  async createStockMovement({ commit }, stock_movement) {
    try {
      const response = await axios.post("/stock-movement", stock_movement);
      commit("addStockMovement", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create stock_movement:", error);
      throw error;
    }
  },
  async fetchStockMovementById(_, id) {
    try {
      const response = await axios.get(`/stock-movement/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stock_movement:", error);
      throw error;
    }
  },
  async updateStockMovement({ commit }, stock_movement) {
    try {
      const response = await axios.put(`/stock-movement/${stock_movement.id}`, stock_movement);
      commit("updateStockMovement", response.data);
    } catch (error) {
      console.error("Failed to update stock_movement:", error);
      throw error;
    }
  },
  async deleteStockMovementById({ commit }, id) {
    try {
      const response = await axios.delete(`/stock-movement/${id}`);
      commit("removeStockMovement", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete stock_movement:", error);
      throw error;
    }
  },
};

const mutations = {
  setStockMovements(state, stock_movements) {
    state.stock_movements = stock_movements.data; // Ensure this matches your API's response structure
  },
  addStockMovement(state, stock_movement) {
    state.stock_movements.push(stock_movement);
  },
  updateStockMovement(state, updatedStockMovement) {
    const index = state.stock_movements.findIndex(
      (stock_movement) => stock_movement.id === updatedStockMovement.id
    );
    if (index !== -1) {
      state.stock_movements.splice(index, 1, updatedStockMovement);
    }
  },
  removeStockMovement(state, id) {
    state.stock_movements = state.stock_movements.filter(
      (stock_movement) => stock_movement.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
